<template>
	<Teleport to="body">
	<div
		class="mdc-dialog"
		role="alertdialog"
		aria-modal="true"
		aria-labelledby="dialog_title"
		aria-describedby="dialog_content"
		ref="modalRef"
	>
		<div class="mdc-dialog__container">
			<div class="mdc-dialog__surface">
				<div class="mdc-dialog__heading">
					<h2 class="mdc-dialog__title" id="dialog_title" v-if="title">{{ title }}</h2>
					<button type="button" class="mdc-icon-button" aria-label="Close Dialog" aria-hidden="false" @click="close()">
						<i class="material-icons">close</i>
					</button>
				</div>
				<div class="mdc-dialog__content" id="dialog_content">
					<slot name="content"></slot>
				</div>
				<footer class="mdc-dialog__actions" v-if="$slots.actions">
					<slot name="actions"></slot>
				</footer>
			</div>
		</div>
		<div class="mdc-dialog__scrim"></div>
	</div>
	</Teleport>
</template>

<script setup>
// TODO: Watchers

// Dependencies
import { MDCDialog } from '@material/dialog'
import { ref, onMounted, watch, } from 'vue'
import { useRoute } from 'vue-router'

// Props
const props = defineProps({
	title: {
		type: String,
		default: '',
	},
	content: String,
	open: Boolean,
})

// Data
let dialog = null
let listener = null
let emitClose = true

// Refs
const modalRef = ref()

const emits = defineEmits(['close'])

// Mounted
onMounted(() => {
	dialog = new MDCDialog(modalRef.value)
	if (props.open) {
		dialog.open()
	}

	dialog.listen('MDCDialog:closed', () => {
		console.log('modal.closed', emitClose)
		if (emitClose) {
			emits('close')
		}
	})
})

// Methods
function close() {
	dialog.close()
}

// Watch
watch(() => props.open, (newVal) => {
	if (newVal) {
		emitClose = true
		dialog.open()
	} else {
		dialog.close()
	}
})

const route = useRoute()
watch(route, (to, from) => {
	if (from) {
		emitClose = false
	}
}, { immediate: true, })

</script>

<style scoped lang="scss">
@use '@material/dialog/mdc-dialog';
// @import '@material/button/mdc-button';
@use "@material/icon-button/mdc-icon-button";

.mdc-dialog {
	z-index: 30;

	&__content {
		overflow: initial;
	}

	&__heading {
		align-items: center;
		border-bottom: 1px solid var(--color--divider);
		display: flex;
		position: relative;

		.mdc-icon-button {
			color: var(--color--secondary-text);
			position: absolute;
			right: 0;
			transform: translateY(4px);

			&__icon {
				font-size: 20px;
			}

			&:hover {
				color: var(--color--primary-text);
			}
		}
	}

	.mdc-dialog__surface {
		@include modules.media-query(desktop) {
			min-width: 580px;
			max-width: 80vw;
		}

		overflow-y: visible;
	}

	&__title {
		flex: 1;
		text-align: center;
	}

}
</style>
